import React, { useState, useEffect } from "react";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import Comment from "./Comment";
import CreateComment from "./CreateComment";
import Button from "components/CustomButton";
import { useLocation } from "react-router-dom";
import { ExpressionsContext } from "store/contexts/expressionsContext";
import { useTeamContext } from "store/contexts/teamContext";
import { useTimelineContext } from "store/contexts/timelineContext";
import { useUserContext } from "store/contexts/userContext";

export default ({ listTask }) => {
  const { team } = useTeamContext();
  const [expressions, setExpressions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);
  const { user } = useUserContext();
  const search = useLocation().search;
  const param = new URLSearchParams(search);
  const [expression_id, setExpressionId] = useState(param.get("expression_id"));
  const [reply_id, setReplyId] = useState(param.get("reply_id") ?? null);
  const { updateTask } = useTimelineContext();
  const loadMoreButtonStyle = {
    display: "flex",
    justifyContent: "center",
    paddingTop: "15px",
  };

  useEffect(() => {
    if (expression_id) {
      setExpressionId(param.get("expression_id"));
    }

    if (reply_id) {
      setReplyId(param.get("reply_id"));
    }
    //eslint-disable-next-line
  }, [search, param]);

  useEffect(() => {
    setIsLoading(true);
    if (expression_id && expressions.length !== 0) {
      setExpressions([]);
    }
    (async () => {
      try {
        if (!expression_id || expression_id === "undefined") {
          const response = await TeamService.getListTaskExpressions(
            team.id,
            listTask.todo_list_id,
            listTask.id,
            { page: page }
          );

          setIsLoading(false);
          setMeta(response.data.meta);
          setExpressions(
            Array.from(new Set([...expressions, ...response.data.data]))
          );
          return;
        }
        const response = await TeamService.getSingleListItemExpression(
          team.id,
          listTask.todo_list_id,
          listTask.id,
          expression_id
        );
        setIsLoading(false);
        setMeta(0);
        setExpressions([response.data.data]);
      } catch (e) {
        console.log(e);
      }
    })();

    // eslint-disable-next-line
  }, [listTask.id, team?.id, page, expression_id]);

  const createExpression = (expression) => {
    setExpressions(Array.from(new Set([expression, ...expressions])));
  };

  const viewMore = () => {
    if (!expression_id) {
      setPage(page + 1);
      return;
    }

    setReplyId(null);
    setExpressionId(null);
    setExpressions([]);
  };

  const deleteExpression = (newExpression) => {
    var newExpressions = expressions.filter(
      (expressions) => expressions.id !== newExpression.id
    );

    var userExpressionExist = newExpressions.some(
      (expression) => expression?.user?.id === user?.id
    );

    if (!userExpressionExist) {
      const postCopy = { ...listTask };

      postCopy.expressions_count -= 1;
      postCopy.user_expressed = false;

      updateTask(postCopy);
    }

    setExpressions(newExpressions);
  };

  const updateExpression = (expression) => {
    const expressionCopy = [...expressions];

    expressionCopy[
      expressionCopy.findIndex((tExpression) => {
        return tExpression.id === expression.id;
      })
    ] = {
      ...expression,
    };

    setExpressions(expressionCopy);
  };

  return (
    <ExpressionsContext.Provider
      value={{
        createExpression,
        deleteExpression,
        updateExpression,
        reply_id,
        setReplyId,
      }}
    >
      <div className="post_comments-section">
        <CreateComment listTask={listTask} />
        <div>
          {expressions.map((expression) => (
            <Comment
              expression={expression}
              key={expression.id}
              listTask={listTask}
            />
          ))}
          {expression_id && !isLoading && expression_id !== "undefined" && (
            <div className="viewAllButton">
              <Button buttonClass={"grad_btn join-btn"} onClick={viewMore}>
                View All
              </Button>
            </div>
          )}
          {page !== meta?.last_page && !isLoading && !expression_id && (
            <div style={loadMoreButtonStyle}>
              <Button
                buttonClass="light-gray-btn d-inline-block"
                onClick={() => setPage(page + 1)}
              >
                Load More
              </Button>
            </div>
          )}
          {isLoading && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Loader />
            </div>
          )}
        </div>
      </div>
    </ExpressionsContext.Provider>
  );
};
